import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Link } from 'react-router'
import InspectionItem from '../InspectionItem'
import { translation, enumtranslate } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
// Constants
import {
  FILE_STORAGE
} from '../../../../constants'
import Gallery from '../../../../shared/components/Gallery'
import UserInfo from '../../../../shared/components/UserInfo'

// Elements
import Button from '../../../../shared/elements/button'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Divider from '../../../../shared/elements/divider'

class ExternalDeviation extends Component {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
    this.renderDeviation = this.renderDeviation.bind(this)
  }

  componentDidMount () {
  }
  renderDeviation (deviation, key) {
    // Render reasons
    const renderReasons = (reasons, k) => {
      const renderReason = (reason, keyReason) => {
        let enumName = (reason.DeviationType.ClassId - 1 === 0) ? 'InternalDeviationTypes' : 'ExternalDeviationTypes'
        let deviationName = enumtranslate(enumName, reason.DeviationType.Type)
        return (
          <div key={keyReason}>
            {translation(deviationName)}
          </div>
        )
      }
      const renderCustomReason = (reason, keyReason) => {
        let deviationName = reason.CustomReason
        return (
          <div key={keyReason}>
            {deviationName}
          </div>
        )
      }
      let side = ''
      if (reasons.Part.TaskSide !== 0) {
        side = (reasons.Part.TaskSide === 1) ? translation('213') : translation('214')
      }
      return (
        <LabelWrapper key={'part_' + k} labelText={side + translation(reasons.Part.DictionaryKey)}>
          {reasons.DeviationReasons.map(renderReason)}
          {reasons.CustomDeviationReasons.map(renderCustomReason)}
        </LabelWrapper>
      )
    }
    // Render image
    const renderImage = (image, index) => {
      // console.log('image', image)
      let url = FILE_STORAGE + (image.OrderFile !== undefined ? image.OrderFile.ThumbURL : image.FileName)
      let fullUrl = FILE_STORAGE + (image.OrderFile !== undefined ? image.OrderFile.FileURL : image.FileName)
      return (
        <div key={index}>
          <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        </div>
      )
    }
    // Return
    return (
      <div key={key}>
        {deviation.Parts.length !== 0 && (
          <div>
            <h3>{translation('333')}</h3>
            <Divider />
            {deviation.Parts.map(renderReasons)}
          </div>
        )}
        {deviation.DeviationFiles.length !== 0 && (
          <div className='category'>
            <h3>{translation('1043')}</h3>
            <Divider />
            <Gallery files={deviation.DeviationFiles} renderImage={renderImage} />
          </div>
        )}
        {deviation.DeviationComment !== null && (
          <div className='category'>
            <h3>{translation('149')}</h3>
            <Divider />
            <LabelWrapper labelText={(<span><UserInfo user={deviation.DeviationComment.UserInfo} />{renderFullDate(deviation.DeviationComment.NoteDate)}</span>)}>
              {deviation.DeviationComment.Note}
            </LabelWrapper>
          </div>
        )}
      </div>
    )
  }

  renderContent () {
    let Deviations = this.props.ExternalWork.Deviations

    return (
      <div>
        {Deviations.map(this.renderDeviation)}
        <Link to={'/pricecalculation/' + this.props.order.Id + '/6'}>
          <Button style='secondary' labelText={translation('311')} />
          {/* <img src='/images/icons/External-deviation-white-VS.png' /> */}
        </Link>
      </div>
    )
  }
  render () {
    if (this.props.ExternalWork === null || this.props.ExternalWork === undefined) return null
    const onHeaderClick = () => {
      this.props.onHeaderClick('ExternalWork')
    }
    let title = { icon: '/images/svgs/inspection/external-deviation.svg', text: '583' }
    return (
      <InspectionItem onHeaderClick={onHeaderClick} title={title} renderContent={this.renderContent} checked={this.props.ExternalWork.Checked} />
    )
  }
}

ExternalDeviation.defaultProps = {
  isBodyshop: false
}

ExternalDeviation.propTypes = {
  isBodyshop: PropTypes.bool,
  ExternalWork: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired
}

ExternalDeviation.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(ExternalDeviation)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/ExternalDeviation/index.js